import { initSite } from "./site.js";

await initSite();

